export default "__VITE_ASSET__CV0uBDz7__"